
import { computed, defineComponent, onMounted, onUnmounted, ref } from 'vue'
import SpinnerLoader from '@/components/SpinnerLoader.vue'

export default defineComponent({
    name: 'DetachChannelModal',
    components: { SpinnerLoader },
    props: {
        opened: {
            type: Boolean,
            default: false,
        },
        channelName: {
            type: String,
            default: '',
        },
        loading: {
            type: Boolean,
            default: false,
        },
        isModule: {
            type: Boolean,
            default: false,
        },
        inTariff: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['cancel', 'create-package'],
    setup(props, { emit }) {
        const cardRef = ref<HTMLElement | null>(null)
        const channelNameSuffix = computed(() => {
            const normalizedName = String(props.channelName || '').trim()
            if (!normalizedName) return ''
            if (normalizedName.toLowerCase() === 'место для подключения канала') return ''
            return ` ${normalizedName}`
        })
        const modalTitle = computed(() => {
            if (props.isModule) return 'Убрать модуль из подписки'
            return props.inTariff ? 'Убрать канал из подписки' : 'Убрать дополнительный канал из подписки'
        })
        const modalDescription = computed(() => {
            if (props.inTariff) {
                return 'До конца оплаченного периода ничего не изменится. После окончания периода его нельзя будет оплатить отдельно — он исчезнет безвозвратно.'
            }
            return props.isModule
                ? 'Этот модуль станет дополнительным. До конца оплаченного периода ничего не изменится, но в дальнейшем продлевать его нужно будет отдельно.'
                : 'Этот канал станет дополнительным модулем. До конца оплаченного периода ничего не изменится, но в дальнейшем продлевать его нужно будет отдельно.'
        })

        const handleCancel = () => {
            if (props.loading) return
            emit('cancel')
        }
        const handleCreatePackage = () => emit('create-package')
        const handleDialogInput = (value: boolean) => {
            if (!value) handleCancel()
        }
        const handleDocumentPointerDown = (event: Event) => {
            if (!props.opened || props.loading) return
            const target = event.target as Node | null
            if (!target) return
            if (cardRef.value?.contains(target)) return
            handleCancel()
        }

        onMounted(() => {
            document.addEventListener('pointerdown', handleDocumentPointerDown, true)
        })
        onUnmounted(() => {
            document.removeEventListener('pointerdown', handleDocumentPointerDown, true)
        })

        return {
            cardRef,
            channelNameSuffix,
            modalTitle,
            modalDescription,
            handleCancel,
            handleCreatePackage,
            handleDialogInput,
        }
    },
})
